<template>
    <div
        v-if="isLoading"
        class="field-spinner pl-2"
    >
        <div
            class="field-spinner__icon"
            :class="isBig ? 'field-spinner__icon-big' : ''"
        />
    </div>
</template>

<script>
export default {
    name: 'DFieldLoading',
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        isBig: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style>
.field-spinner__icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    border: solid 2px transparent;
    border-top-color: #fec600;
    border-left-color: #fec600;
    border-radius: 50%;
    -webkit-animation: nprogress-spinner 400ms linear infinite;
    animation: nprogress-spinner 400ms linear infinite;
}
.field-spinner__icon-big {
    width: 72px;
    height: 72px;
}
</style>
